// libs
import React, { useState, useEffect, memo } from "react";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";

// Local components
import MetaInfo from "shared/components/AdPlatformWidgets/components/MetaInfo";
import Carousel from "./components/Carousel";
import Grid from "./components/Grid";
import SlidingWidget from "./components/SlidingWidget";
import InFocus from "./components/InFocus";

// types
import { ILandingPageProps } from "shared/components/AdPlatformWidgets/types";

// helpers
import { WIDGET_TYPES, SSR_CSR_SPLIT } from "shared/components/AdPlatformWidgets/constants";
import { getMetaData } from "shared/components/AdPlatformWidgets/helpers";

// styles
import { WidgetsContainer } from "shared/components/AdPlatformWidgets/styles";

const COMPONENTS = {
    [WIDGET_TYPES.CAROUSEL]: Carousel,
    [WIDGET_TYPES.COLUMN_GRID]: Grid,
    [WIDGET_TYPES.TEXT_GRID]: Grid,
    [WIDGET_TYPES.DATA_WIDGET]: SlidingWidget,
    [WIDGET_TYPES.SLIDING_WIDGET]: SlidingWidget,
    [WIDGET_TYPES.IN_FOCUS]: InFocus,
};

function AdPlatformWidgetsDesktop({ landingPageData }: ILandingPageProps) {
    const [landingData, setLandingData] = useState(landingPageData.slice(0, SSR_CSR_SPLIT));
    const metaData = getMetaData(landingPageData);

    useEffect(() => {
        setLandingData(landingPageData);
    }, [landingPageData]);

    const Elements = landingData.map((widget, id) => {
        const Component = COMPONENTS[get(widget, "widget_data.wtype")];

        if (isEmpty(Component)) return null;

        return <Component key={id} widget={widget} />;
    });

    return (
        <main>
            <MetaInfo metaData={metaData} />
            <WidgetsContainer>{Elements}</WidgetsContainer>
        </main>
    );
}

export default memo(AdPlatformWidgetsDesktop);
